import {
  Component,
  ViewEncapsulation,
  OnInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  BehaviorSubject,
  Observable
  , Subscription
} from 'rxjs';
import {
  AccountsService
} from './accounts.service';
import {
  FormControl
} from '@angular/forms';
import {Router} from '@angular/router';
import {UserContext} from "../services/user-context/user-context";
import {AccountDialogComponent} from './detail/components/account-dialog/account-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../services/api/api.service';
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {LocationSummaryService} from '../services/location-summary-service';
import {SearchContext} from '../services/search/search-context';



@Component({
  selector: 'app-accounts',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'accounts.template.html'
})
export class AccountsComponent implements OnInit {
  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  public search: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private searchSubscription: Subscription;

  loading = false;

  constructor(
    private router: Router,
    private service: AccountsService,
    public dialog: MatDialog,
    private searchContext: SearchContext,
    private api: ApiService,
    private locationSummaryService: LocationSummaryService,
    private snackBar: MatSnackBar,
    private userContext: UserContext) {

    this.view = service;
    this.subscription = service.subscription;
  }

  public ngOnInit(): void {
    this.searchSubscription = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
      if ((term || "").length >= 3 || (term || "").length === 0) {
        this.state.skip = 0;
        this.search.next(term || "");
      }
    });
    this.search.subscribe(term => {
      this.getAccounts();
    })
  }

  public ngOnDestroy(): void {
    this.search.unsubscribe();
  }

  public addAccount(): void {
    const dialogRef = this.dialog.open(AccountDialogComponent, {
      width: '750px'
    });

    dialogRef.afterClosed().subscribe(account => {

      if ( account ) {
        this.api.post<any>(`/account`, account ).subscribe( result => {
          this.userContext.account = result;
          this.locationSummaryService.locationObserver.next(true);
          this.router.navigate(['', 'accounts', `${result._id}`]);
        }, (error) => {
          this.snackBar.open(`Error adding account: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public selectedRow(event: SelectionEvent) {
      this.userContext.account = event.selectedRows[0].dataItem;
      this.locationSummaryService.locationObserver.next(true);
      this.router.navigate(['', 'accounts', `${event.selectedRows[0].dataItem._id}`]);
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getAccounts();
  }

  public getAccounts() {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getList(page, limit, () => {
      this.loading = false;
    }, this.search.value);
  }

}
